import React from "react";
import { Modal } from "antd";
import IncidentModal from "../IncidentModal";
import IncidentHistoryModal from "../IncidentHistoryModal";
import ActivityListModal from "../ActivityListModal";
import ClassificationModal from "../ClassificationModal";
import InvestigationPanel from "../InvestigationPanel";
import DeleteIncidentModal from "../DeleteIncidentModal";
import ApprovalSection from "@iso/components/HealthSafetyApproval/ApprovalSection";

const IncidentActionModals = ({
  // State from useIncidentActions
  modalVisible,
  selectedIncident,
  historyModalVisible,
  activityModalVisible,
  approvalModalIncident,
  classifyModalVisible,
  classifyIncident,
  investigationVisible,
  investigationIncident,
  deleteIncident,

  // Handlers from useIncidentActions
  handleModalClose,
  handleHistoryModalClose,
  handleActivityModalClose,
  handleIncidentModalSaved,
  handleApprovalClose,
  handleClassifyClose,
  handleInvestigationClose,
  handleDeleteClose,
  handleDeleted,

  // Consumer-provided props
  isSafetyAdmin,
  currentUserId,
  canDecideApproval,
  onRefresh,
  onApprovalUpdated,
}) => {
  const normalizedCurrentUserId =
    typeof currentUserId === "number"
      ? currentUserId
      : Number(currentUserId);

  return (
    <>
      <IncidentModal
        visible={modalVisible}
        incident={selectedIncident}
        propertyId={selectedIncident?.property_id}
        onSaved={handleIncidentModalSaved}
        onCancel={handleModalClose}
      />

      <DeleteIncidentModal
        incident={deleteIncident}
        onCancel={handleDeleteClose}
        onDeleted={handleDeleted}
      />

      <IncidentHistoryModal
        visible={historyModalVisible}
        incident={selectedIncident}
        onCancel={handleHistoryModalClose}
      />

      <ActivityListModal
        visible={activityModalVisible}
        incident={selectedIncident}
        onCancel={handleActivityModalClose}
      />

      <Modal
        open={Boolean(approvalModalIncident)}
        onCancel={handleApprovalClose}
        footer={null}
        destroyOnClose
        title="Approve Incident"
      >
        {approvalModalIncident && (
          <ApprovalSection
            model="incident"
            objectId={approvalModalIncident.id}
            latestApproval={approvalModalIncident.latest_approval}
            canDecide={canDecideApproval}
            onApprovalUpdated={(approval) => {
              if (typeof onApprovalUpdated === "function") {
                onApprovalUpdated(approvalModalIncident.id, approval);
              }
              handleApprovalClose();
            }}
          />
        )}
      </Modal>

      <ClassificationModal
        visible={classifyModalVisible}
        incident={classifyIncident}
        propertyId={classifyIncident?.property_id}
        onCancel={handleClassifyClose}
        onSaved={() => {
          onRefresh();
        }}
      />

      <InvestigationPanel
        visible={investigationVisible}
        incident={investigationIncident}
        isSafetyAdmin={isSafetyAdmin}
        isInvestigator={
          investigationIncident &&
          Number(investigationIncident.investigator_id) === normalizedCurrentUserId
        }
        onCancel={handleInvestigationClose}
        onUpdated={() => {
          onRefresh();
        }}
      />
    </>
  );
};

export default IncidentActionModals;
